import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import * as moment from 'moment';
import { SettingsService } from '../../../core/settings/settings.service';
import { CeqTableComponent } from '../../common/ceq-table/ceq-table.component';
import { DeleteChildRendered } from '../../common/renders/delete-child-rendered';
import { EditChildRendered } from '../../common/renders/edit-child-rendered';
import { Unit } from '../../common/models/Unit.Model';
import { Container } from '../../common/models/Container.Model';
import { InventoryService } from '../inventory.service';
import { BalanceDetail } from '../../common/models/BalanceDetail.Model';
import { Balance } from '../../common/models/Balance.Model';
import { MldBalance } from '../../common/models/MldBalance.Model';
import { ContainerType } from '../../common/models/ContainerType.Model';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';

interface ContainerBalance {
  containerId: number;
  total: number;
}

interface dataRow {
  date: Date;
  reference: string;
  items: number[];
}

interface LevelDetail {
  name: string;
  unitId: number
}

@Component({
  selector: 'app-balance',
  templateUrl: './mld-balance.component.html',
  styleUrls: ['./mld-balance.component.scss']
})
export class MldBalanceComponent implements OnInit {

  constructor(private router: Router,
    private inventoryService: InventoryService,
    private globalFunctionService: GlobalFunctionsService,
    private settings: SettingsService) { }

  loading: boolean = false;
  levelList: Unit[];
  levelListB: Unit[];
  selectedLevelA: Unit;
  selectedLevelB: Unit;
  containerList: Container[];
  containerTypeList: ContainerType[];
  initialData: any[] = [];
  org: number;
  balance: Balance[];

  level: number = 0;
  levelB: number = 0;
  TCA: number = 0;
  GT: number = 0;
  TAA: number = 0;
  TCB: number = 0;
  TAB: number = 0;
  InitialDate: string;
  FinalDate: string;
  PosBalance: Balance[];
  PosNode: number = 0;
  actualDate = new Date();

  containersSet: ContainerBalance[] = [];
  containersSetB: ContainerBalance[] = [];

  dataList: dataRow[] = [];
  dataListB: dataRow[] = [];

  nodesA: LevelDetail[];
  nameNode: string = 'name';

  nodesB: LevelDetail[];

  container: number;

  orgunit: number;

  options: GridOptions;
  optionsB: GridOptions;
  PageSizes = [10, 25, 50, 100, 1000];

  searchingDetail: boolean = false;

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
  }


  gridOptionsB = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },

    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { }


  }


  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  @ViewChild('CeqGridB', { static: false }) ceqGridB: CeqTableComponent;

  columnDefsNodoA = [
    {
      headerName: 'Fecha',
      field: 'DateMove',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      cellRenderer: (params: any) => moment(params.data.DateMove).format('YYYY-MM-DD'),
      cellStyle: function (params) {
        if (params.data.UnitIdB == params.context.levelB) {
          return { color: '#FFFFFF', backgroundColor: '#6CAA82' };
        }
        return null;
      }

    },
    {
      headerName: 'Referencia',
      field: 'Reference',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      cellStyle: function (params) {
        if (params.data.UnitIdB == params.context.levelB) {
          return { color: '#FFFFFF', backgroundColor: '#6CAA82' };
        }
        return null;
      }
    },
    {
      headerName: 'Cargo',
      field: 'Quantity',
      width: 20,
      cellClass: 'align-right',
      editable: false,
      cellRenderer: (params: any) => params.data.Quantity > 0 ? params.data.Quantity : "",
      cellStyle: function (params) {
        if (params.data.UnitIdB == params.context.levelB) {
          return { color: '#FFFFFF', backgroundColor: '#6CAA82' };
        }
        return null;
      }

    }
    ,
    {
      headerName: 'Abono',
      field: 'Quantity',
      width: 20,
      cellClass: 'align-right',
      editable: false,
      cellRenderer: (params: any) => params.data.Quantity < 0 ? params.data.Quantity : "",
      cellStyle: function (params) {
        if (params.data.UnitIdB == params.context.levelB) {
          return { color: '#FFFFFF', backgroundColor: '#6CAA82' };
        }
        return null;
      }

    }
  ];

  columnDefsNodoB = [
    {
      headerName: 'Fecha',
      field: 'DateMove',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      cellRenderer: (params: any) => moment(params.data.DateMove).format('YYYY-MM-DD'),
      cellStyle: function (params) {
        if (params.data.UnitIdB == params.context.level) {
          return { color: '#FFFFFF', backgroundColor: '#6CAA82' };
        }
        return null;
      }
    },
    {
      headerName: 'Referencia',
      field: 'Reference',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      cellStyle: function (params) {
        if (params.data.UnitIdB == params.context.level) {
          return { color: '#FFFFFF', backgroundColor: '#6CAA82' };
        }
        return null;
      }
    },
    {
      headerName: 'Cargo',
      field: 'Quantity',
      width: 20,
      cellClass: 'align-right',
      editable: false,
      cellRenderer: (params: any) => params.data.Quantity > 0 ? params.data.Quantity : "",
      cellStyle: function (params) {
        if (params.data.UnitIdB == params.context.level) {
          return { color: '#FFFFFF', backgroundColor: '#6CAA82' };
        }
        return null;
      }


    },
    {
      headerName: 'Abono ',
      field: 'Quantity',
      width: 20,
      cellClass: 'align-right',
      editable: false,
      cellRenderer: (params: any) => params.data.Quantity < 0 ? params.data.Quantity : "",
      cellStyle: function (params) {
        if (params.data.UnitIdB == params.context.level) {
          return { color: '#FFFFFF', backgroundColor: '#6CAA82' };
        }
        return null;
      }

    }
  ];
  ngOnInit(): void {
    this.level = 0;
    this.levelB = 0;

    this.org = this.settings.getUser().Org;
    this.getLevelList();
    this.getLevelListB();
  }


  onPageSizeChange(value: number) {

  }
  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.ceqGrid.endPoint = "balancedetail?$filter=Org eq " + 0;
    this.ceqGrid.refreshTable();
  }

  gridEmiterB(GridOptions: GridOptions) {
    this.optionsB = GridOptions;
    this.ceqGridB.endPoint = "balancedetail?$filter=Org eq " + 0;
    this.ceqGridB.refreshTable();
  }

  getLevelList(): void {
    this.inventoryService.getLevelList(this.org).subscribe((resp: Unit[]) => {
      this.levelList = resp;
      if (resp !== null) {
        this.nodesA = resp.map(unit => {
          return {
            name: `${unit.UnitCode} - ${unit.UnitDescription}`,
            unitId: unit.UnitId
          }
        });
      }
      const orgAll: Unit = new Unit();
      if (this.levelList !== null) {
        this.levelList.unshift(orgAll);
      }
    }, async err => {
      await this.globalFunctionService.messageBimbo('Error al obtener lista de niveles, verifique su conexión a internet', 'warning', '');
    });
  }

  getContainerList(filter: string): void {
    this.inventoryService.getConteinerList(filter).subscribe((resp: Container[]) => {
      this.containerList = resp;
      const containerAll: Container = new Container();
      if (this.containerList !== null) {
        this.containerList.unshift(containerAll);
      }
      this.getBalanceBetweenNodes();
    }, async err => {
      await this.globalFunctionService.messageBimbo('Error al obtener lista de contenedores, verifique su conexión a internet', 'warning', '');
    });
  }


  getContainerTypeList(filter: string): void {
    this.inventoryService.getConteinerTypeList(filter).subscribe((resp: ContainerType[]) => {
      this.containerTypeList = resp;
      const containerAll: ContainerType = new ContainerType();
      if (this.containerTypeList !== null) {
        this.containerTypeList.unshift(containerAll);
      }
      this.getBalanceBetweenNodes();
    }, async err => {
      await this.globalFunctionService.messageBimbo('Error al obtener lista de contenedores, verifique su conexión a internet', 'warning', '');
    });
  }

  changeFilterLevel(event: any): void {
    this.level = event.unitId;
    this.selectedLevelA = this.levelList.find(unt => unt.UnitId === Number(event.unitId));
    this.getContainersByFactory();
  }

  changeFilterLevelB(event: any): void {
    this.levelB = event.unitId;
    this.selectedLevelB = this.levelListB.find(unt => unt.UnitId === Number(event.unitId));
    this.getContainersByFactory();
  }

  getContainersByFactory() {
    this.containerList = [];
    this.balance = [];
    if (this.selectedLevelA && this.selectedLevelB) {
      this.inventoryService.getContainersByFactory(this.level).subscribe(resp => {
        if (resp) {
          if (resp.length === 0) {
            this.inventoryService.getContainersByCeve(this.level).subscribe(resp => {
              this.getContainers(resp);
            });
          } else {
            this.getContainers(resp);
          }
        } else {
          this.inventoryService.getContainersByCeve(this.level).subscribe(resp => {
            this.getContainers(resp);
          });
        }
      });
    }
  }

  getContainers(containersByNode: any): void {
    const containers: number[] = containersByNode.map(cnt => cnt.ContainerId);
    if (containers.length === 0) {
      this.globalFunctionService.messageToast(`El nodo A seleccionado no cuenta con equipo asignado.`, 'warning');
      return;
    }
    let filter = '';
    containers.map(id => {
      filter += `${id}, `;
    });
    this.getContainerList(filter.substring(0, filter.length - 2));
    this.getContainerTypeList(filter.substring(0, filter.length - 2));
  }

  changeFilterContainer(event: any): void {
    this.container = event;
  }

  clearNodeA(): void {
    this.dataList = [];
    this.dataListB = [];
    this.level = undefined;
    this.selectedLevelB = undefined;
  }

  clearNodeB(): void {
    this.dataList = [];
    this.dataListB = [];
    this.levelB = undefined;
    this.selectedLevelB = undefined;
  }

  getBalanceBetweenNodes(): void {
    if (this.selectedLevelA && this.selectedLevelB) {
      this.containersSet = [];
      this.dataList = [];
      this.loading = true;
      this.inventoryService.getBalanceByNodesMld(this.org, this.selectedLevelA.UnitId, this.selectedLevelB.UnitId).subscribe((balance: MldBalance[]) => {
        const containersId = this.containerList.map(cnt => cnt.ContainerId);
        this.balance = balance.filter(bln => containersId.includes(bln.ConteinerId));
        this.loading = false;
      }, err => {
        this.loading = false;
        console.log(err)
      });
    }
  }

  getContainerCode(containerId: number): string {
    const container = this.containerList.find(cnt => cnt.ContainerId === containerId);
    if (container) {
      return container.ContainerName;
    }
    return 'Inactivo';
  }


  getContainerType(containerId: number, containerTypeId: number): string {
    const containerType = this.containerTypeList.find(cnt => cnt.ContainerTypeId === containerTypeId);
    if (containerType) {
      return containerType.ContainerTypeDescription;
    }
    return '';
  }

  getLevelListB(): void {
    this.inventoryService.getAllFactoryCeve().subscribe((resp: Unit[]) => {
      this.levelListB = resp;
      if (resp !== null) {
        this.nodesB = resp.map(unit => {
          return {
            name: `${unit.UnitCode} - ${unit.UnitDescription}`,
            unitId: unit.UnitId
          }
        });
      }
      const orgAll: Unit = new Unit();
      if (this.levelListB !== null) {
        this.levelListB.unshift(orgAll);
      }
    }, async err => {
      await this.globalFunctionService.messageBimbo('Error al obtener lista de niveles, verifique su conexión a internet', 'warning', '');
    });
  }


  async btnClick(): Promise<void> {
    if (this.level == null) {
      await this.globalFunctionService.messageBimbo('Error es necesario seleccionar un nodo A', 'warning', '');
      return

    }

    if (this.levelB == null) {
      await this.globalFunctionService.messageBimbo('Error es necesario seleccionar un nodo B', 'warning', '');
      return
    }

    if (this.level == this.levelB) {
      await this.globalFunctionService.messageBimbo('El nodo A y el B no puden ser el mismo', 'warning', '');
      return
    }

    if (this.InitialDate == null) {
      await this.globalFunctionService.messageBimbo('Seleccione una fecha inicial', 'warning', '');
      return
    }


    if (this.FinalDate == null) {
      await this.globalFunctionService.messageBimbo('Seleccione una fecha final', 'warning', '');
      return
    }
    let fa = new Date(this.InitialDate);
    let fb = new Date(this.FinalDate);
    if (fb.getTime() < fa.getTime()) {
      await this.globalFunctionService.messageBimbo('La fecha inicial es mayor a la fecha final', 'warning', '');
      return
    }

    this.loadData();

    console.log('dataList');
    console.log(this.dataList);
    console.log('dataListB');
    console.log(this.dataListB);
  }

  loadData(): void {
    this.searchingDetail = true;
    this.inventoryService.getBalanceDetailByNodes(this.org, this.level, this.levelB, this.InitialDate, this.FinalDate).subscribe((data: BalanceDetail[]) => {
      this.containersSet = [];
      this.dataList = [];
      this.containersSet = [... new Set(this.balance.map(bln => {
        return {
          containerId: bln.ConteinerId,
          total: 0
        };
      }))];
      if (data) {
        data.map(bln => {
          let container = this.containersSet.find(cnt => cnt.containerId === bln.ConteinerId)
          if (!container) return;
          container.total += bln.Quantity;
          let item: dataRow = {
            date: bln.DateMove,
            reference: bln.Reference,
            items: []
          };
          const exists = this.dataList.find(data => data.reference === item.reference);
          let index = 0;
          item.items = this.containersSet.map(cnt => {
            if (exists && cnt.containerId === bln.ConteinerId) {
              exists.items[index] = bln.Quantity;
            }
            index++;
            return cnt.containerId === bln.ConteinerId ? bln.Quantity : 0;
          });

          if (!exists) {
            this.dataList.push(item);
          }
        });
      }
      this.searchingDetail = false;
    }, err => {
      this.searchingDetail = false;
    });

    this.inventoryService.getBalanceDetailByNodes(this.org, this.levelB, this.level, this.InitialDate, this.FinalDate).subscribe((data: BalanceDetail[]) => {
      this.containersSetB = [];
      this.dataListB = [];
      this.containersSetB = [... new Set(this.balance.map(bln => {
        return {
          containerId: bln.ConteinerId,
          total: 0
        };
      }))];
      if (data) {
        data.map(bln => {
          let container = this.containersSetB.find(cnt => cnt.containerId === bln.ConteinerId)
          if (!container) return;
          container.total += bln.Quantity;
          let item: dataRow = {
            date: bln.DateMove,
            reference: bln.Reference,
            items: []
          };
          const exists = this.dataListB.find(data => data.reference === item.reference);
          let index = 0;
          item.items = this.containersSetB.map(cnt => {
            if (exists && cnt.containerId === bln.ConteinerId) {
              exists.items[index] = bln.Quantity;
            }
            index++;
            return cnt.containerId === bln.ConteinerId ? bln.Quantity : 0;
          });

          if (!exists) {
            this.dataListB.push(item);
          }
        });
      }
      this.searchingDetail = false;
    }, err => {
      this.searchingDetail = false;
    });
  }
}
